import { DateInput, type DateInputProps } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import { formatDay, parseDay } from '../format.js';
import { useDatesLabels } from './dates.js';

export interface DayInputProps
  extends Omit<
    DateInputProps,
    'value' | 'defaultValue' | 'onChange' | 'valueFormat' | 'dateParser' | 'minDate' | 'maxDate'
  > {
  /** Gün `YYYY-MM-DD` (gemi yerel tarihi; CLAUDE.md "Zaman"); boşsa `null`. */
  value: string | null | undefined;
  onChange: (value: string | null) => void;
  /** En erken ve en geç gün `YYYY-MM-DD` (ör. "gelecek tarih yok": bugün). */
  minDate?: string | undefined;
  maxDate?: string | undefined;
}

/**
 * Gün girişi (M6f G1-04; ADR 0033): `GG.AA.YYYY` yazılır ya da takvimden seçilir. İşletim
 * sisteminin dil biçiminden bağımsızdır (yerel `<input type="date">` yerine).
 */
export function DayInput({
  value,
  onChange,
  minDate,
  maxDate,
  leftSection,
  rightSection,
  readOnly,
  placeholder,
  ...rest
}: DayInputProps) {
  const labels = useDatesLabels();
  const icon =
    leftSection || rightSection !== undefined || readOnly ? (
      rightSection
    ) : (
      <IconCalendar size={16} aria-hidden />
    );
  return (
    <DateInput
      {...rest}
      value={value || null}
      onChange={onChange}
      valueFormat={formatDay}
      dateParser={parseDay}
      locale={labels.locale}
      previousLabel={labels.previousLabel}
      nextLabel={labels.nextLabel}
      placeholder={placeholder ?? labels.datePlaceholder}
      readOnly={readOnly ?? false}
      leftSection={leftSection}
      rightSection={icon}
      {...(rest.clearable
        ? // Temizle düğmesinin erişilebilir adı (axe button-name)
          { clearButtonProps: { 'aria-label': labels.clearDate } }
        : { rightSectionPointerEvents: 'none' as const })}
      {...(minDate ? { minDate } : {})}
      {...(maxDate ? { maxDate } : {})}
    />
  );
}
